// extracted by mini-css-extract-plugin
export var bodyRow = "_ek-d";
export var cardColumns = "_ek-e";
export var ellipsesOverflow = "_ek-2";
export var flatBottomCorners = "_ek-3";
export var flatTopCorners = "_ek-4";
export var headerActionsDropdown = "_ek-f";
export var headerBottomRow = "_ek-c";
export var headerTopRow = "_ek-b";
export var orderDetailsWrapper = "_ek-0";
export var orderInfoContainer = "_ek-1";
export var productDetails = "_ek-9";
export var productImage = "_ek-5";
export var responsiveTable = "_ek-8";
export var shipmentContainer = "_ek-a";
export var tableBottomLeft = "_ek-6";
export var tableBottomRight = "_ek-7";
export var trackingLink = "_ek-g";